var _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _feGaussianBlur5, _feGaussianBlur6, _feGaussianBlur7, _feGaussianBlur8, _feGaussianBlur9, _feGaussianBlur0, _feGaussianBlur1, _feGaussianBlur10, _feGaussianBlur11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFpc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 765.631,
    height: 561.338,
    viewBox: "0 0 202.573 148.521",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "a",
    x: -0.019,
    y: -0.021,
    width: 1.037,
    height: 1.041
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "b",
    x: -0.031,
    y: -0.028,
    width: 1.062,
    height: 1.055
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "c",
    x: -0.025,
    y: -0.024,
    width: 1.05,
    height: 1.049
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "d",
    x: -0.094,
    y: -0.042,
    width: 1.188,
    height: 1.084
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "e",
    x: -0.041,
    y: -0.031,
    width: 1.082,
    height: 1.063
  }, _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "f",
    x: -0.094,
    y: -0.042,
    width: 1.188,
    height: 1.084
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "g",
    x: -0.041,
    y: -0.031,
    width: 1.082,
    height: 1.063
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "h",
    x: -0.035,
    y: -0.03,
    width: 1.071,
    height: 1.059
  }, _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "i",
    x: -0.046,
    y: -0.033,
    width: 1.092,
    height: 1.067
  }, _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "j",
    x: -0.031,
    y: -0.028,
    width: 1.062,
    height: 1.055
  }, _feGaussianBlur0 || (_feGaussianBlur0 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "k",
    x: -0.083,
    y: -0.041,
    width: 1.165,
    height: 1.081
  }, _feGaussianBlur1 || (_feGaussianBlur1 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "l",
    x: -0.016,
    y: -0.018,
    width: 1.031,
    height: 1.037
  }, _feGaussianBlur10 || (_feGaussianBlur10 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "m",
    x: -0.034,
    y: -0.032,
    width: 1.069,
    height: 1.064
  }, _feGaussianBlur11 || (_feGaussianBlur11 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.009
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#a)"
    },
    d: "m8 99.47 90.5-52.5v30L8 129.47Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#b)"
    },
    d: "m114.328 58.875 54.345 31.387v30l-54.345-31.387Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#c)"
    },
    d: "m46.53 98.141 67.703-39.291v30L46.53 128.141Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#d)"
    },
    d: "m46.53 98.158 18.057 10.211v30L46.53 128.16Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#e)"
    },
    d: "m64.507 108.36 41.566-24.126v30L64.508 138.36z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#f)"
    },
    d: "m106.165 84.285 18.058 10.21v30l-18.058-10.21Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#g)"
    },
    d: "m82.6 118.714 41.565-24.125v30L82.6 148.714z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#h)"
    },
    d: "m120.65 117.4 48.05-27.126v30L120.65 147.4Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#i)"
    },
    d: "M120.65 117.474 157.6 138.3v30l-36.95-20.826z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#j)"
    },
    d: "m82.578 118.771 54.974 31.288v30l-54.974-31.288Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#k)"
    },
    d: "m116.712 162.095 20.508-11.845v30l-20.508 11.845z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      filter: "url(#l)"
    },
    d: "m7.884 99.564 108.6 62.536v30l-108.6-62.536Z",
    transform: "translate(-6.188 -45.275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#d10c33",
      fillOpacity: 1,
      stroke: "#fff",
      strokewidth: 3.35,
      strokelinecap: "round",
      strokelinejoin: "round",
      strokemiterlimit: 20,
      strokedasharray: "none",
      strokeopacity: 1,
      filter: "url(#m)"
    },
    d: "m157.675 138.3 39.846-23.245 9.545 9.358-9.545 20.642-39.846 23.245Z",
    transform: "translate(-6.188 -45.275)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFpc);
export default __webpack_public_path__ + "static/media/logoFPC.8e9233aa7a5876804c153c2f97cf7fe7.svg";
export { ForwardRef as ReactComponent };